import { Request } from "../../request";
import { getURL } from "../../utils";

// dashboard
export const get_dashboard = () => {
    return Request.get(getURL(`/api/corporation-pa/content/dashboard/`));
  };